import { AuditDetailsFormData } from "../models";

export const toAuditDetailsFormData = (
  at?: string | null,
  userName?: string | null,
  personName?: string | null,
): AuditDetailsFormData => {
  if (at) {
    return {
      at,
      userName,
      personName,
    };
  } else {
    return {
      at: "",
    };
  }
};
